import React from "react"

import { useApiContext } from "~/api"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Diagram: React.FC = () => {
  const { structure } = useApiContext("/stocks/info")

  const sortedStructure = structure
    .map(({ name, percent }) => ({
      name,
      percent,
      width: Number.parseFloat(percent.replace(",", ".")),
    }))
    .sort((a, b) => b.width - a.width)

  return (
    <div>
      <div className={styles.Bars}>
        {sortedStructure.map(({ name, percent, width }) => (
          <div key={name} className={styles.Bar} style={{ width: `${width}%` }}>
            <Heading className={styles.BarTitle} like="h3">
              {percent}
              <span>%</span>
            </Heading>

            <div className={styles.BarColor} style={{ width: `${width}%` }} />
            <div className={styles.BarPale} />
          </div>
        ))}
      </div>

      <div className={styles.Legend}>
        {sortedStructure.map(({ name }) => (
          <div key={name} className={styles.LegendItem}>
            <Raw html={name} />
          </div>
        ))}
      </div>
    </div>
  )
}
